import { cleanLocalStorage, setLocalStorageItem } from './localStorage';

export const logout = () => {
	cleanLocalStorage();
	setLocalStorageItem('last_url', window.location.href);

	window.location = '/login';
};
